// eslint-disable-next-line import/prefer-default-export
export const auctioneerDataMatrixQuantityValidator = (t, minQuantity, maxQuantity) => (input) => {
    let err = null;
    const parsedInput = parseInt(input, 10);
    if (input.trim().length === 0) {
        err = t('auctioneer-data-matrix.validation.auctioneer-data-matrix-empty-quantity');
    } else if (!input.match(/^\d+$/)) {
        err = t('auctioneer-data-matrix.validation.auctioneer-data-matrix-quantity-invalid-integer');
    } else if (parsedInput < minQuantity) {
        err = t('auctioneer-data-matrix.validation.auctioneer-data-matrix-quantity-too-low', { minQuantity });
    } else if (parsedInput > maxQuantity) {
        err = t('auctioneer-data-matrix.validation.auctioneer-data-matrix-quantity-too-high', { maxQuantity });
    }
    return err;
};
